import { useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useModule } from "../contexts/ModuleContext";
import NotFoundPage from "../pages/NotFoundPage";

type PermissionAction = "view" | "add" | "edit" | "approve" | "delete";

interface PermissionRouteProps {
  children: React.ReactElement;
  requiredAction?: PermissionAction;
}

const PermissionRoute = ({
  children,
  requiredAction = "view",
}: PermissionRouteProps) => {
  const { permissions } = useAuth();
  const { getScreenIdByPath, loading } = useModule();
  const location = useLocation();

  if (loading) {
    return children;
  }

  const screenId = getScreenIdByPath(location.pathname);

  if (!screenId) {
    return <NotFoundPage />;
  }

  const screenPermission = permissions?.[screenId];

  if (!screenPermission) {
    return <NotFoundPage />;
  }

  const hasPermission = screenPermission[requiredAction];

  if (!hasPermission) {
    return <NotFoundPage />;
  }

  console.log("Current Path:", location.pathname);
  console.log("Resolved ScreenId:", screenId);

  return children;
};

export default PermissionRoute;